import React, {Component} from 'react';
import { connect } from 'react-redux';

import paths from 'paths';
import { formatDateDMY, formatDateHM } from 'utils/formatDate';

import GenderIcon from 'components/GenderIcon';
import ProfileAvatar from 'components/ProfileAvatar';
import { Link } from 'components/ReactRouterDomLocalized';

import '../../sass/member/MemberMessageItem.scss';

import { actionFilterMemberMessage } from 'reducers/memberMessageList';

class MessageListItem extends Component {
    constructor(props) {
        super(props);

        this.state = {
            chek: false,
            checked: false,
        };
    }

    componentWillReceiveProps(nextProps) {
        const chek = nextProps.chek;
        const chekNow = this.state.chek;

        chek !== chekNow ? this.setState({checked: chek, chek: chek}) : false;
        nextProps.onApply ? this.setState({checked: false, chek: false}) : false;
    }

    setChooseListMessage = () => {
        const { checked } = this.state;
        const { setChooseListMessage, item: { conversation_id }} = this.props;

        setChooseListMessage(conversation_id, !checked);

        this.setState({
            checked: !this.state.checked
        })
    }

    markAsRead = () => {
        const { actionFilterMemberMessage, item: {conversation_id, old }} = this.props;
        if (!old) {
            actionFilterMemberMessage({ ids: conversation_id, action: 'read' });
        }
    }

    render() {
        const { checked } = this.state;
        const { old, date, author, message, recipient, conversation_id } = this.props.item;
    
        const profile = conversation_id === recipient.id ? recipient : author;

        return (
            <div className={`item-message ${!old ? 'new' : ''} ${checked ? 'active' : ''}`}>
                    <div className="chek">
                        <div className="checkbox">
                            <input type="checkbox" id={conversation_id} checked={checked ? "checked" : ""} onChange={this.setChooseListMessage} />
                            <label htmlFor={conversation_id} />
                        </div>
                    </div>
                    <Link to={profile.profile_url} className="avatar">
                        <ProfileAvatar user={profile} />
                    </Link>
                    <Link to={paths.memberMessageDialog.path + conversation_id} className="text-one-message" onClick={this.markAsRead}>
                        <div className="name-one-message">
                            <GenderIcon user={profile} />
                            <span className={`nick ${!old ? 'new' : ''}`}>{profile.nick}</span>
                        </div>
                        <p className={!old ? 'new' : ''} dangerouslySetInnerHTML={{__html: message}} />
                    </Link>
                <div className="time">
                    <p className={!old ? 'new' : ''} title={formatDateHM(date)}>{formatDateDMY(date)}</p>
                </div>
            </div>
        )
    }
}

const mapDispatchToProps = {
    actionFilterMemberMessage
}

export default connect(null, mapDispatchToProps)(MessageListItem);



// WEBPACK FOOTER //
// ./src/components/message/MessageListItem.js